import {Injectable} from '@angular/core';
import {ColorReplaceService} from './color-replace.service';
import {MapAssetRepresentation} from '../model/custom/map/map-asset-representation';
import {AssetRepresentationsService} from './asset-representations.service';

@Injectable({
  providedIn: 'root'
})
export class MapIconsService {

  public readonly DEFAULT_ICON = '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';

  public readonly DEFAULT_ICON_MAIN_COLOR = '#8f8f8f';

  public readonly DEFAULT_NEW_ICON_MAIN_COLOR = '#407ec9';

  public DEFAULT_NEW_ICON: string;

  public readonly iconMap: Map<string, MapAssetRepresentation>;

  constructor(private replaceColorService: ColorReplaceService, private assetRepresentationsService: AssetRepresentationsService) {
    this.iconMap = new Map();
    this.replaceColorService.changeColorImg('data:image/png;base64,' + this.getDefaultIcon(), this.getDefaultIconMainColor(), this.DEFAULT_NEW_ICON_MAIN_COLOR).then((result) => {
      this.DEFAULT_NEW_ICON = result.split('data:image/png;base64,')[1];
    });
  }

  async buildCustomIconBy(identifier: string, mapAssetRepresentation: MapAssetRepresentation): Promise<MapAssetRepresentation> {
    if (mapAssetRepresentation.icon) {
      if (mapAssetRepresentation?.status && mapAssetRepresentation.targetColor) {
        const img = await this.replaceColorService.changeColorImg('data:image/png;base64,' + mapAssetRepresentation.icon, mapAssetRepresentation.targetColor, this.assetRepresentationsService.getColorFromLoadedPreferences(mapAssetRepresentation.status));
        mapAssetRepresentation.icon = img.split(',')[1];
        this.iconMap.set(identifier, mapAssetRepresentation);
        return mapAssetRepresentation;
      }
    }
  }

  public queueBuildCustomIconBy(identifier: string, mapAssetRepresentation: MapAssetRepresentation): Promise<MapAssetRepresentation> {
    this.iconMap.set(identifier, null);
    return this.buildCustomIconBy(identifier, mapAssetRepresentation);
  }

  getIcon(identifier: string): string {
    return this.iconMap.get(identifier)?.icon;
  }

  hasIcon(identifier: string): boolean {
    return this.iconMap.has(identifier);
  }

  setIcon(identifier: string, mapRepresentation: MapAssetRepresentation): void {
    this.iconMap.set(identifier, mapRepresentation);
  }

  getDefaultIcon(): string {
    return this.DEFAULT_ICON;
  }

  getNewDefaultIcon(): string {
    return this.DEFAULT_NEW_ICON;
  }

  getDefaultIconMainColor(): string {
    return this.DEFAULT_ICON_MAIN_COLOR;
  }

  getNewDefaultIconMainColor(): string {
    return this.DEFAULT_NEW_ICON_MAIN_COLOR;
  }

  cleanCustomIcons() {
    for (const key of this.iconMap.keys()) {
      if (!key.includes('undefined')) {
        this.iconMap.delete(key);
      }
    }
  }

}
